import { render } from "./map.vue?vue&type=template&id=059c0c4a&scoped=true"
import script from "./map.vue?vue&type=script&lang=js"
export * from "./map.vue?vue&type=script&lang=js"

import "./map.vue?vue&type=style&index=0&id=059c0c4a&lang=less&scoped=true"

import exportComponent from "/home/bula/demo/bula2023/vue/bula2023/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059c0c4a"]])

export default __exports__